import { closeModal } from 'actions/modal';
import { archiveHub, archiveKit, archiveTemplate } from 'actions/requests';
import Button from 'components/atoms/Button';
import Typography from 'components/atoms/Typography';
import { DiscoverItem, DiscoverItemDescriptor, DiscoverItemType } from 'utils/gloo-types';
import { startCase } from 'lodash';
import { toast } from 'react-toastify';
import { useThunkDispatch } from 'utils/reduxHook';
import ModalWrapper from './ModalWrapper';

interface ArchiveDiscoverItemModalProps {
  descriptor: DiscoverItemDescriptor;
  onArchivedAtChange: (archivedAt?: Date) => void;
  parents: DiscoverItem[];
}

const ArchiveDiscoverItemModal = ({ descriptor, onArchivedAtChange, parents }: ArchiveDiscoverItemModalProps) => {
  const dispatch = useThunkDispatch();

  const formattedDiscoverItemType = startCase(descriptor.type);

  const onCancel = () => {
    dispatch(closeModal());
  };

  const onArchive = async () => {
    let archivedAt: Date;
    switch (descriptor.type) {
      case DiscoverItemType.HUB: {
        const archivedHub = await dispatch(archiveHub(descriptor.id));
        archivedAt = archivedHub.archivedAt;
        break;
      }
      case DiscoverItemType.KIT: {
        const archivedKit = await dispatch(archiveKit(descriptor.id));
        archivedAt = archivedKit.archivedAt;
        break;
      }
      case DiscoverItemType.TEMPLATE: {
        const archivedTemplate = await dispatch(archiveTemplate(descriptor.id));
        archivedAt = archivedTemplate.archivedAt;
        break;
      }
    }
    onArchivedAtChange(archivedAt);
    toast.info(`You successfully archived your ${formattedDiscoverItemType}`);
    dispatch(closeModal());
  };

  return (
    <ModalWrapper closeOnEscapeKey closeOnBackgroundClick>
      <div className="flex flex-col gap-6">
        <Typography variant="h1">Are you sure?</Typography>
        <Typography variant="base">
          {parents.length ? (
            <>This resource is currently active for multiple Hubs and/or Kits. Are you sure you want to Archive?</>
          ) : (
            <>
              Are you sure you want to archive your {formattedDiscoverItemType}? You will be able to access this again
              in the archive library. However, until it is unarchived, it cannot be displayed, and the link will not be
              accessible.
            </>
          )}
        </Typography>
        <div>
          <div className="flex flex-row gap-4 justify-end">
            <Button type="tertiary" dataDurableId="archiveDiscoverItemModalCancelButton" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="navy" dataDurableId="archiveDiscoverItemModalArchiveButton" onClick={onArchive}>
              Archive {formattedDiscoverItemType}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ArchiveDiscoverItemModal;
